import { render, staticRenderFns } from "./soft_version_list.vue?vue&type=template&id=4f2546d4"
import script from "./soft_version_list.vue?vue&type=script&lang=js"
export * from "./soft_version_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports